import { EmptyState } from '@saas-ui/react';
import { HiOutlineDocument } from 'react-icons/hi2';

type Props = {
  title: string;
  description: string;
};

export const Error = ({ title, description }: Props) => {
  return <EmptyState colorScheme="brand" icon={HiOutlineDocument} title={title} description={description} />;
};
